module.exports = __webpack_public_path__ + "img/footer_img2.057d93f7.png";